import { fetchData } from "./utils";

export const getMarketingInvestmentReports = () => {
  return fetchData("/power_bi_api/midas_fidelity");
};
